<template>
  <div>
    <div
      v-if="!report"
      class="col-12"
      style="background: #fff; padding: 150px;"
    >
      <div class="col-12 text-center">
        <p>
          <i class="fas fa-chart-line fa-4x"></i>
        </p>
        {{ this.$t('reports.emptyMsg') }}
      </div>
    </div>
    <div
      v-else-if="
        report &&
        report !== 'Relatório de Mapa - NPS' &&
        report !== 'Relatório Mapa Mundi' &&
        report !== 'NPS por Indicadores' &&
        report !== 'Relatório de METAS' &&
        report !== 'Nuvem de Palavras' &&
        report !== 'Categorias' &&
        report !== 'Comparativo de Ações' &&
        report !== 'Detratores Recorrentes' &&
        report !== 'Quadro Resumo' &&
        report !== 'Status dos Disparos' &&
        report !== 'Comparativo Regional e Nacional' &&
        report !== 'Status de Tratativas' &&
        report !== 'CXI – Pós Vendas' &&
        report !== 'CXI Pós-vendas 2024 (360)' &&
        report !== 'Relatório CXI - Vendas' &&
        report !== 'Relatório CXI Vendas - Caminhões' &&
        report !== 'Analise por dispositivo' &&
        report !== 'Análise de sentimento' &&
        report !== 'Relatório CXI Vendas - Vans' &&
        report !== 'Relatório Auditoria' &&
        report !== 'Monitoramento de pesquisa' &&
        report !== 'Relatório Prévia de Índices' &&
        report !== 'Relatório de Índices por Consultor' &&
        report !== 'Evolução de Categorias' &&
        report !== 'Relatório de Conversão / Detalhamento Importação' &&
        report !== 'Relatório HTS' &&
        report !== 'Categoria x Tag Tratativa' &&
        report !== 'Monitoramento de Tratativa' &&
        report !== 'Relatório Impacto dos Lembretes'
      "
      class="cards"
    >
      <div
        v-if="
          report &&
          report !== 'Categorias' &&
          report !== 'Comparativo de Ações' &&
          report !== 'Rankings' &&
          report !== 'Nuvem de Palavras' &&
          report !== 'NPS por Indicadores' &&
          report !== 'Relatório de METAS' &&
          report !== 'Relatório de Mapa - NPS' &&
          report !== 'Relatório Mapa Mundi' &&
          report !== 'Analise por dispositivo' &&
          report !== 'Análise de sentimento' &&
          report !== 'Evolução de Categorias' &&
          report !== 'Relatório de Conversão / Detalhamento Importação' &&
          report !== 'Relatório HTS' &&
          report !== 'Categoria x Tag Tratativa' &&
          report !== 'Monitoramento de Tratativa' &&
          report !== 'Relatório Impacto dos Lembretes'
        "
        class="custom-switch"
      >
        <div>
          <b-form-select
            v-model="reportType"
            :options="options"
            style="width: 200px;"
            @change="switchDataSource"
          ></b-form-select>
        </div>
      </div>

      <div v-if="report === 'Rankings'" class="custom-switch">
        <b-dropdown
          size="xl"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
          id="dropdown-profile"
        >
          <template v-slot:button-content>
            {{ $t('reports.selectProfile') }}
          </template>

          <b-dropdown-text>
            <div
              class="custom-control custom- my-1 mr-sm-2"
              v-for="(item, i) in returnFilters()"
              :key="i"
            >
              <input
                type="checkbox"
                class="custom-control-input"
                :value="item"
                :id="item.name"
                :name="item.name"
                @change="updateFilter(i, $event.target.checked, returnFilters())"
              />
              <template v-if="myMetric && myMetric.indexOf('ces') >= 0 || myMetric === 'like-dislike'">
                 <label class="custom-control-label" :for="item.name">
                  {{ item.text }}
                </label>
              </template>
              <template v-else>
                <label class="custom-control-label" :for="item.name">
                  {{ $t(`reports.${item.name}Label`) }}
                </label>
              </template>
            </div>
          </b-dropdown-text>
        </b-dropdown>
      </div>

      <div
        v-if="
          report &&
          report !== 'Categorias' &&
          report !== 'Comparativo de Ações' &&
          report !== 'Rankings' &&
          report !== 'Nuvem de Palavras' &&
          report !== 'NPS por Indicadores' &&
          report !== 'Relatório de METAS' &&
          report !== 'Relatório de Mapa - NPS' &&
          report !== 'Relatório Mapa Mundi' &&
          report !== 'Status dos Disparos' &&
          report !== 'Relatório CXI Vendas - Caminhões' &&
          report !== 'Análise de sentimento' &&
          report !== 'Relatório CXI Vendas - Vans' &&
          report !== 'Relatório Auditoria' &&
          report !== 'Evolução de Categorias' &&
          report !== 'Relatório de Conversão / Detalhamento Importação' &&
          report !== 'Relatório HTS' &&
          report !== 'Categoria x Tag Tratativa' &&
          report !== 'Monitoramento de Tratativa' &&
          report !== 'Relatório Impacto dos Lembretes'
        "
        class="custom-switch"
        style="margin-left: 40px;"
      >
        <input
          type="checkbox"
          class="custom-control-input"
          id="swich-accumulated-value"
          v-model="checkedAccumulated"
          @change="switchReport"
        />
        <label class="custom-control-label" for="swich-accumulated-value"
          >Acumulado</label
        >
      </div>

      <div
        v-if="
          report &&
          report !== 'Categorias' &&
          report !== 'Comparativo de Ações' &&
          report !== 'Rankings' &&
          report !== 'Nuvem de Palavras' &&
          report !== 'NPS por Indicadores' &&
          report !== 'Relatório de METAS' &&
          report !== 'Relatório de Mapa - NPS' &&
          report !== 'Relatório Mapa Mundi' &&
          report !== 'Comparativo Indicadores' &&
          report !== 'Disponibilidade de Peças' &&
          report !== 'Relatório CXI Vendas - Caminhões' &&
          report !== 'Análise de sentimento' &&
          report !== 'Relatório CXI Vendas - Vans' &&
          report !== 'Comparativo de Categorias' &&
          report !== 'Relatório Comparativo de N1 e N2' &&
          report !== 'Relatório Auditoria' &&
          report !== 'Evolução de Categorias' &&
          report !== 'Relatório de Conversão / Detalhamento Importação' &&
          report !== 'Relatório HTS' &&
          report !== 'Categoria x Tag Tratativa' &&
          report !== 'Monitoramento de Tratativa' &&
          report !== 'Relatório Impacto dos Lembretes'
        "
        class="icons-grid"
      >
        <i
          title="Barras"
          class="fas fa-chart-bar"
          @click="switchChart('column')"
        ></i>
      </div>

      <div
        v-if="
          report &&
          report !== 'Categorias' &&
          report !== 'Comparativo de Ações' &&
          report !== 'Rankings' &&
          report !== 'Nuvem de Palavras' &&
          report !== 'NPS por Indicadores' &&
          report !== 'Relatório de METAS' &&
          report !== 'Relatório de Mapa - NPS' &&
          report !== 'Relatório Mapa Mundi' &&
          report !== 'Comparativo Indicadores' &&
          report !== 'Disponibilidade de Peças' &&
          report !== 'Relatório CXI Vendas - Caminhões' &&
          report !== 'Análise de sentimento' &&
          report !== 'Relatório CXI Vendas - Vans' &&
          report !== 'Comparativo de Categorias' &&
          report !== 'Relatório Comparativo de N1 e N2' &&
          report !== 'Relatório Auditoria' &&
          report !== 'Evolução de Categorias' &&
          report !== 'Relatório de Conversão / Detalhamento Importação' &&
          report !== 'Relatório HTS' &&
          report !== 'Categoria x Tag Tratativa' &&
          report !== 'Monitoramento de Tratativa' &&
          report !== 'Relatório Impacto dos Lembretes'
        "
        class="icons-grid"
      >
        <i
          title="Área"
          class="fas fa-chart-area"
          @click="switchChart('area')"
        ></i>
      </div>

      <div
        v-if="
          report &&
          report !== 'Categorias' &&
          report !== 'Comparativo de Ações' &&
          report !== 'Rankings' &&
          report !== 'Nuvem de Palavras' &&
          report !== 'NPS por Indicadores' &&
          report !== 'Relatório de METAS' &&
          report !== 'Relatório de Mapa - NPS' &&
          report !== 'Relatório Mapa Mundi' &&
          report !== 'Comparativo Indicadores' &&
          report !== 'Disponibilidade de Peças' &&
          report !== 'Relatório CXI Vendas - Caminhões' &&
          report !== 'Análise de sentimento' &&
          report !== 'Relatório CXI Vendas - Vans' &&
          report !== 'Comparativo de Categorias' &&
          report !== 'Relatório Comparativo de N1 e N2' &&
          report !== 'Relatório Auditoria' &&
          report !== 'Evolução de Categorias' &&
          report !== 'Relatório de Conversão / Detalhamento Importação' &&
          report !== 'Relatório HTS' &&
          report !== 'Categoria x Tag Tratativa' &&
          report !== 'Monitoramento de Tratativa' &&
          report !== 'Relatório Impacto dos Lembretes'
        "
        class="icons-grid"
      >
        <i
          title="Linha"
          class="fas fa-chart-line"
          @click="switchChart('line')"
        ></i>
      </div>
      <div
        v-if="
          report &&
          report !== 'Comparativo Indicadores' &&
          report !== 'Evolução de NPS' &&
          report !== 'Disponibilidade de Peças' &&
          report !== 'Comparativo de Categorias' &&
          report !== 'Relatório Comparativo de N1 e N2' &&
          report !== 'Evolução de Perguntas Adicionais' &&
          report !== 'Relatório Impacto dos Lembretes'
        "
        class="volumes"
      >
        <div style>
          <span class="icon answers">
            <i class="fas fa-comment-dots"></i>
          </span>
          <span class="label">
            <p style="margin-top: 13px;">
              <b>
                {{ this.$t('reports.answersLabel') }}
              </b>
              <br />
              <span>
                <animated-number
                  :value="emotionCards.answers"
                  :formatValue="formatToPrice"
                  :duration="1500"
                />
              </span>
            </p>
          </span>
        </div>
        <div>
          <span class="icon promoters">
            <i class="far fa-grin"></i>
          </span>
          <span class="label">
            <p style="margin-top: 13px;">
              <b>
                {{ this.summary.promotersText }}
              </b>
              <br />
              <span>
                <animated-number
                  :value="emotionCards.promoters"
                  :formatValue="formatToPrice"
                  :duration="1500"
                />
                -
                <animated-number
                  :value="setPerctanage(emotionCards.promotersPercentil)"
                  :formatValue="formatToPrice"
                  :duration="1500"
                />%
              </span>
            </p>
          </span>
        </div>
        <div v-if="myMetric !== 'like-dislike'">
          <span class="icon neutrals">
            <i class="far fa-meh"></i>
          </span>
          <span class="label">
            <p style="margin-top: 13px;">
              <b>
                {{ this.summary.passivesText }}
              </b>
              <br />
              <span>
                <animated-number
                  :value="emotionCards.passives"
                  :formatValue="formatToPrice"
                  :duration="1500"
                />
                -
                <animated-number
                  :value="setPerctanage(emotionCards.passivesPercentil)"
                  :formatValue="formatToPrice"
                  :duration="1500"
                />%
              </span>
            </p>
          </span>
        </div>
        <div>
          <span class="icon detractors">
            <i class="far fa-frown"></i>
          </span>
          <span class="label">
            <p style="margin-top: 13px;">
              <b>
                {{ this.summary.detractorsText }}
              </b>
              <br />
              <span>
                <animated-number
                  :value="emotionCards.detractors"
                  :formatValue="formatToPrice"
                  :duration="1500"
                />
                -
                <animated-number
                  :value="setPerctanage(emotionCards.detractorsPercentil)"
                  :formatValue="formatToPrice"
                  :duration="1500"
                />%
              </span>
            </p>
          </span>
        </div>
        <div>
          <span class="icon nps">
            <i class="fas fa-chart-line"></i>
          </span>
          <span class="label">
            <p style="margin-top: 13px;">
              <b>{{ summary.metric }}</b
              ><br />
              <span>
                <span v-if="emotionCards.nps === null"> - </span>
                <animated-number
                  v-else
                  :value="setPerctanage(emotionCards.nps)"
                  :formatValue="formatToNps"
                  :duration="1500"
                />
              </span>
            </p>
          </span>
        </div>
      </div>
    </div>

    <div
      class="report"
      :style="
        report === 'Categorias' ||
        report === 'Rankings' ||
        report === 'Monitoramento de Tratativa' ||
        report === 'Análise de sentimento'
          ? reportCategories
          : ''
      "
    >
      <basic-column
        :reportType="reportType"
        :accumulated="checkedAccumulated"
        v-if="report === 'Evolução de NPS'"
      />
      <answer-evolution
        :reportType="reportType"
        :accumulated="checkedAccumulated"
        v-else-if="report === 'Evolução de Respostas'"
      />
      <invites-evolution
        :reportType="reportType"
        :accumulated="checkedAccumulated"
        v-else-if="report === 'Evolução de Convites'"
      />
      <evolution-percentage
        :reportType="reportType"
        :accumulated="checkedAccumulated"
        v-else-if="report === 'Evolução de Percentuais'"
      />
      <surveys-invites
        :reportType="reportType"
        v-else-if="report === 'Monitoramento de pesquisa'"
      />
      <monitoring-treatment
        :reportType="reportType"
        v-else-if="report === 'Monitoramento de Tratativa'"
      />
      <rankings v-else-if="report === 'Rankings'" />
      <comparative-actions v-else-if="report === 'Comparativo de Ações'" />
      <categories-chart v-else-if="report === 'Categorias'" />
      <treatments-tags-chart v-else-if="report === 'Tags de Tratativas'" />
      <word-clound v-else-if="report === 'Nuvem de Palavras'" />
      <indicators-chart v-else-if="report === 'NPS por Indicadores'" />
      <metas v-else-if="report === 'Relatório de METAS'" />
      <map-chart v-else-if="report === 'Relatório de Mapa - NPS'" />
      <map-mundi-chart v-else-if="report === 'Relatório Mapa Mundi'" />
      <evolution-additional-questions
        :reportType="reportType"
        :accumulated="checkedAccumulated"
        v-else-if="report === 'Evolução de Perguntas Adicionais'"
      />
      <comparative-indicators
        :accumulated="checkedAccumulated"
        v-else-if="report === 'Comparativo Indicadores'"
      />
      <detractor-report v-else-if="report === 'Detratores Recorrentes'" />
      <summary-board v-else-if="report === 'Quadro Resumo'" />
      <group-nps v-else-if="report === 'Comparativo Regional e Nacional'" />
      <invite-status v-else-if="report === 'Status dos Disparos'" />
      <treatment-status v-else-if="report === 'Status de Tratativas'" />
      <cxi-report v-else-if="report === 'CXI – Pós Vendas'" />
      <cxi-report-2024 v-else-if="report === 'CXI Pós-vendas 2024 (360)'" />
      <cxi-sales-report v-else-if="report === 'Relatório CXI - Vendas'" />
      <parts-availability v-else-if="report === 'Disponibilidade de Peças'" />
      <mercedes-sales
        v-else-if="report === 'Relatório CXI Vendas - Caminhões'"
      />
      <deviceAnalysis v-else-if="report === 'Analise por dispositivo'" />
      <sentmentAnalysis v-else-if="report === 'Análise de sentimento'" />
      <mercedes-sales-vans
        v-else-if="report === 'Relatório CXI Vendas - Vans'"
      />
      <comparative-categories
        :accumulated="checkedAccumulated"
        :reportPeriod="reportType"
        v-else-if="report === 'Comparativo de Categorias'"
      />
      <comparative-n1-n2
        :accumulated="checkedAccumulated"
        :reportPeriod="reportType"
        v-else-if="report === 'Relatório Comparativo de N1 e N2'"
      />
      <auditReport v-else-if="report === 'Relatório Auditoria'" />
      <index-preview v-else-if="report === 'Relatório Prévia de Índices'" />
      <index-consultant
        v-else-if="report === 'Relatório de Índices por Consultor'"
      />
      <categories-evolution v-else-if="report === 'Evolução de Categorias'" />
      <conversion-details
        v-else-if="
          report === 'Relatório de Conversão / Detalhamento Importação'
        "
      />
      <mercedes-hts v-else-if="report === 'Relatório HTS'" />
      <categories-tags v-else-if="report === 'Categoria x Tag Tratativa'" />
      <reminder-impact v-else-if="report === 'Relatório Impacto dos Lembretes'" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import animatedNumber from 'animated-number-vue';
import basicColumn from '@/components/molecules/highcharts/reports/basicColumn';
import answerEvolution from '@/components/molecules/highcharts/reports/answer-evolution';
import invitesEvolution from '@/components/molecules/highcharts/reports/invites-evolution';
import evolutionPercentage from '@/components/molecules/highcharts/reports/evolution-percentage';
import rankings from '@/components/molecules/highcharts/reports/rankings';
import comparativeActions from '@/components/molecules/comparative-actions';
import categoriesChart from '@/components/molecules/highcharts/reports/categories';
import treatmentsTagsChart from '@/components/molecules/highcharts/reports/treatments-tags';
import indicatorsChart from '@/components/molecules/highcharts/reports/indicators';
import metas from '@/components/molecules/highcharts/reports/metas';
import wordClound from '@/components/molecules/highcharts/word-cloud';
import mapChart from '@/components/molecules/highcharts/map-chart';
import mapMundiChart from '@/components/molecules/highcharts/map-mundi-chart';
import evolutionAdditionalQuestions from '@/components/molecules/highcharts/evolution-additional-questions';
import comparativeIndicators from '@/components/molecules/highcharts/comparative-indicators';
import detractorReport from '@/components/molecules/highcharts/detractor-report';
import summaryBoard from '@/components/molecules/highcharts/summary-board';
import groupNps from '@/components/molecules/highcharts/group-nps';
import inviteStatus from '@/components/molecules/highcharts/invite-status';
import treatmentStatus from '@/components/molecules/highcharts/treatment-status';
import cxiReport from '@/components/molecules/highcharts/cxi-report';
import cxiReport2024 from '@/components/molecules/highcharts/cxi-report-2024';
import cxiSalesReport from '@/components/molecules/highcharts/cxi-sales-report';
import partsAvailability from '@/components/molecules/highcharts/parts-availability';
import mercedesSales from '@/components/molecules/highcharts/mercedes-sales';
import mercedesSalesVans from '@/components/molecules/highcharts/mercedes-sales-vans';
import deviceAnalysis from '@/components/molecules/highcharts/device-analysis';
import sentmentAnalysis from '@/components/molecules/highcharts/sentment-analysis';
import comparativeCategories from '@/components/molecules/highcharts/comparative-categories';
import comparativeN1N2 from '@/components/molecules/highcharts/comparative-n1-n2';
import auditReport from '@/components/molecules/highcharts/mercedes-audit-report';
import SurveysInvites from '@/components/molecules/highcharts/reports/surveys-invites';
import monitoringTreatment from '@/components/molecules/highcharts/monitoring-treatment';
import indexPreview from '@/components/molecules/highcharts/index-preview';
import indexConsultant from '@/components/molecules/highcharts/index-consultant';
import categoriesEvolution from '@/components/molecules/highcharts/categories-evolution';
import conversionDetails from '@/components/molecules/highcharts/conversion-details';
import mercedesHts from '@/components/molecules/highcharts/mercedes-hts';
import categoriesTags from '@/components/molecules/highcharts/reports/categoriesAndTags';
import reminderImpact from '@/components/molecules/highcharts/reports/reminder-impact';
import EventBus from '../../../eventBus';

export default {
  name: 'ReportsEmotionCards',
  data: () => ({
    options: [],
    selected: 'daily',
    filter: [],
    selectedFilters: [
      { name: 'promoter', selected: false },
      { name: 'neutral', selected: false },
      { name: 'detractor', selected: false },
    ],
    selectedFilters1to5: [
      { name: 'promoter', text:'4-5', selected: false },
      { name: 'neutral', text:'3', selected: false },
      { name: 'detractor', text:'1-2', selected: false },
    ],
    selectedFiltersLikeDislike: [
      { name: 'promoter', text:'Like (1)', selected: false },
      { name: 'detractor', text:'Dislike (0)', selected: false },
    ],
    userAuth: null,
    emotionCards: {
      answers: 0,
      promoters: 0,
      promotersPercentil: 0,
      passives: 0,
      passivesPercentil: 0,
      detractors: 0,
      detractorsPercentil: 0,
      nps: null,
      ces: null,
    },
    // report: 'nps-evolution',
    report: null,
    reportType: 'month',
    checkedMonthly: false,
    checkedAccumulated: true,
    reportCategories: {
      backgroundColor: 'transparent',
      border: '1px solid transparent',
      borderRadius: '4px',
      color: '#5f6368',
      borderTopLeftRadius: '0',
      borderTopRightRadius: '0',
      borderTopColor: 'none',
      marginTop: '-2px',
      padding: '0',
    },
    summary: {
      metric: '',
      promotersText: '',
      passivesText: '',
      detractorsText: '',
    },
  }),

  components: {
    basicColumn,
    animatedNumber,
    answerEvolution,
    invitesEvolution,
    evolutionPercentage,
    rankings,
    comparativeActions,
    categoriesChart,
    treatmentsTagsChart,
    wordClound,
    indicatorsChart,
    metas,
    mapChart,
    mapMundiChart,
    evolutionAdditionalQuestions,
    comparativeIndicators,
    detractorReport,
    summaryBoard,
    inviteStatus,
    groupNps,
    treatmentStatus,
    cxiReport,
    cxiSalesReport,
    partsAvailability,
    mercedesSales,
    deviceAnalysis,
    sentmentAnalysis,
    mercedesSalesVans,
    comparativeCategories,
    auditReport,
    SurveysInvites,
    indexPreview,
    indexConsultant,
    categoriesEvolution,
    conversionDetails,
    mercedesHts,
    categoriesTags,
    monitoringTreatment,
    reminderImpact,
    comparativeN1N2,
    cxiReport2024
  },

  watch: {
    report: function watchReport(value) {
      if (value === 'Monitoramento de Tratativa') {
        EventBus.$emit('isReportMonitoringTreatment', true);
      } else {
        EventBus.$emit('isReportMonitoringTreatment', false);
      }
    },
    actionGroupData: function watchActionGroup() {
      this.setEmotionsData();
    },
    myActionId: function watchMyActionId() {
      this.setEmotionsData();
    },
    myActionsIds: function watchMyActionsIds(){
      this.setEmotionsData();
    },
    myIh1: function watchMyIh1() {
      this.setEmotionsData();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.setEmotionsData();
    },
    myIh2: function watchMyIh2() {
      this.setEmotionsData();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.setEmotionsData();
    },
    calendarDates: function watchDates() {
      if (this.report && this.report === 'Evolução de Convites' || this.report === 'Evolução de Percentuais' ||
        this.report === 'Rankings' || this.report === 'Tags de Tratativas' || this.report === 'Evolução de Respostas') {
        this.setEmotionsData();
      }
    },
    myMetric: function watchMyMetric() {
      this.setEmotionsData();
      this.changeSummaryLabels();
    },
    'indicatorData.value': function watchIndicatorData() {
      this.setEmotionsData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.setEmotionsData();
    },
  },

  methods: {
    ...mapActions('charts', ['getEmotionsReportsData', 'setFilterRankings']),
    ...mapActions('calendar'),
    setPerctanage(percentage) {
      if (percentage !== 'NaN') {
        return percentage;
      }

      return 0;
    },
    formatToPrice(value) {
      return value.toFixed(0);
    },
    formatToNps(value) {
      return value.toFixed(1);
    },
    switchReport(event) {
      EventBus.$emit('accumulated-report', event.target.checked);
    },
    switchChart(type) {
      EventBus.$emit('switch-chart', type);
    },
    switchDataSource(event) {
      EventBus.$emit('data-source', event);
    },
    setEmotionsData() {
      this.getEmotionsReportsData({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.emotionCards.answers = this.reportsEmotions.total;

        this.emotionCards.promoters = this.reportsEmotions.promoters;
        this.emotionCards.promotersPercentil = (
          (this.reportsEmotions.promoters / this.reportsEmotions.total) *
          100
        ).toFixed(2);

        this.emotionCards.passives = this.reportsEmotions.passives;
        this.emotionCards.passivesPercentil = (
          (this.reportsEmotions.passives / this.reportsEmotions.total) *
          100
        ).toFixed(2);

        this.emotionCards.detractors = this.reportsEmotions.detractors;
        this.emotionCards.detractorsPercentil = (
          (this.reportsEmotions.detractors / this.reportsEmotions.total) *
          100
        ).toFixed(2);

        if (this.myMetric.indexOf('nps') >= 0) {
          if(this.reportsEmotions.rounding){
            this.emotionCards.nps = Math.round(
            (
              (this.reportsEmotions.promoters / this.reportsEmotions.total) *
              100
            ).toFixed(1) -
            (
              (this.reportsEmotions.detractors / this.reportsEmotions.total) *
              100
            ).toFixed(1));
          } else{
            this.emotionCards.nps =
            (
              (this.reportsEmotions.promoters / this.reportsEmotions.total) *
              100
            ).toFixed(1) -
            (
              (this.reportsEmotions.detractors / this.reportsEmotions.total) *
              100
            ).toFixed(1);
          }
        } else if (this.myMetric.indexOf('ces') >= 0) {
          this.emotionCards.nps = (
            this.reportsEmotions.totalDividendCes /
            (this.emotionCards.promoters +
              this.emotionCards.passives +
              this.emotionCards.detractors)
          ).toFixed(2);
        } else if (this.myMetric === 'csat-0-10(media)') {
          this.emotionCards.nps = (
            this.reportsEmotions.totalDividendCsat010 /
            (this.emotionCards.promoters +
              this.emotionCards.passives +
              this.emotionCards.detractors)
          ).toFixed(2);
        } else if (this.myMetric === 'csat-1-5') {
          const total =
            this.emotionCards.promoters +
            this.emotionCards.passives +
            this.emotionCards.detractors;
          this.emotionCards.nps = (
            (this.emotionCards.promoters / total) *
            100
          ).toFixed(1);
        } else if (this.myMetric === 'csat-1-5(media)') {
          const total =
            this.emotionCards.promoters +
            this.emotionCards.passives +
            this.emotionCards.detractors;
          this.emotionCards.nps = (
            this.reportsEmotions.totalDividendCsat / total
          ).toFixed(2);
        } else if (this.myMetric.indexOf('stars') >= 0) {
          this.emotionCards.nps = (
            this.reportsEmotions.totalDividendCes /
            (this.emotionCards.promoters +
              this.emotionCards.passives +
              this.emotionCards.detractors)
          ).toFixed(2);
        }
      });
    },
    filterRankings() {
      this.setFilterRankings(this.filter);
      EventBus.$emit('filter-rankings', true);
    },
    updateFilter(index, ev, array) {
      array[index].selected = ev;
      this.filter = array
        .filter((item) => item.selected)
        .map((a) => {
          return a.name;
        });

      this.filterRankings();
    },

    returnFilters() {
       if (this.myMetric.indexOf('nps') >= 0) {
         return this.selectedFilters;
       } else if (this.myMetric.indexOf('ces') >= 0){
         return this.selectedFilters1to5;
       } else if (this.myMetric === 'like-dislike') {
         return this.selectedFiltersLikeDislike;
       }
       return this.selectedFilters;
    },

    changeSummaryLabels() {
      if (this.myMetric.indexOf('nps') >= 0) {
        this.summary.metric = 'NPS';
        this.summary.promotersText = this.$t('reports.promoterLabel');
        this.summary.passivesText = this.$t('reports.neutralLabel');
        this.summary.detractorsText = this.$t('reports.detractorLabel');
      } if (this.myMetric === 'csat-0-10(media)') {
        this.summary.metric = 'CSAT';
        this.summary.promotersText = '9 e 10';
        this.summary.passivesText = '7 e 8';
        this.summary.detractorsText = '0-6';
      } else if (this.myMetric.indexOf('ces') >= 0) {
        this.summary.metric = 'CES';
        this.summary.promotersText = '5-4';
        this.summary.passivesText = '3';
        this.summary.detractorsText = '2-1';
      } else if (this.myMetric === 'csat-1-5') {
        this.summary.metric = 'CSAT';
        this.summary.promotersText = '5-4';
        this.summary.passivesText = '3';
        this.summary.detractorsText = '2-1';
      } else if (this.myMetric === 'csat-1-5(media)') {
        this.summary.metric = 'CSAT (Média)';
        this.summary.promotersText = '5-4';
        this.summary.passivesText = '3';
        this.summary.detractorsText = '2-1';
      } else if (this.myMetric.indexOf('stars') >= 0) {
        this.summary.metric = '5-Stars';
        this.summary.promotersText = '5-4';
        this.summary.passivesText = '3';
        this.summary.detractorsText = '2-1';
      } else if (this.myMetric === 'like-dislike') {
        this.summary.metric = 'Like/Dislike';
        this.summary.promotersText = 'Like';
        this.summary.passivesText = '';
        this.summary.detractorsText = 'Dislike';
      }
    },
  },

  computed: {
    ...mapState('charts', ['reports']),
    ...mapState('charts', ['reportsEmotions']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.options = [
      { value: 'day', text: this.$t('reports.dailyLabel') },
      { value: 'month', text: this.$t('reports.monthlyLabel') },
      { value: 'week', text: this.$t('reports.weeklyLabel') },
      { value: 'quarter', text: this.$t('reports.quarterlyLabel') },
    ];
  },

  async mounted() {
    // this.setEmotionsData();

    // this.report = 'nps-evolution';
    this.report = null;

    EventBus.$on('report', (value) => {
      this.report = value;

      if (this.report && this.report === 'Evolução de Convites' || this.report === 'Evolução de Percentuais' ||
        this.report === 'Rankings' || this.report === 'Tags de Tratativas' || this.report === 'Evolução de Respostas') {
        this.setEmotionsData();
      }

      if (value === 'Comparativo Indicadores') {
        this.options = [
          { value: 'day', text: this.$t('reports.dailyLabel') },
          { value: 'month', text: this.$t('reports.monthlyLabel') },
        ];
        this.reportType = 'month';
        EventBus.$emit('data-source', 'month');
      } else {
        this.options = [
        { value: 'day', text: this.$t('reports.dailyLabel') },
        { value: 'month', text: this.$t('reports.monthlyLabel') },
        { value: 'week', text: this.$t('reports.weeklyLabel') },
        { value: 'quarter', text: this.$t('reports.quarterlyLabel') },
        ];
      }
    });

    this.changeSummaryLabels();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.cards {
  border: 1px solid $gray-light;
  border-radius: 4px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-color: none;
  position: relative;
  height: 65px;
  width: 100%;
  background-color: $white;
  display: flex;
  align-items: center;
  color: $title-color;
  padding: 0 8px;
  > div {
    border-right: 1px solid $gray-light;
    padding: 8px 16px 8px 8px;
  }
  .icons-grid {
    padding-left: 16px;
    > i {
      opacity: 0.7;
      transition: all 0.2s linear;
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }
  }
  .cards,.volumes{
    display: block;
  width: 100%;
  margin-top: 7rem;
  background-color: #fff;
  }

  .volumes {
    display: flex;
    position: absolute;
    top: -7;
    left: 0;
    right: 0;
    padding: 8px;

    > div {
      text-align: center;
      padding: 0 15px;
      .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        // border: 2px solid red;
        width: 40px;
        height: 40px;
        // padding: 10px;
        border-radius: 30px;
        float: left;
        font-size: 2.2em;
        line-height: 1px;
      }
      .icon.answers {
        color: #be4bdb;
      }
      .icon.promoters {
        color: $primary;
      }
      .icon.neutrals {
        color: $grade-seven;
      }
      .icon.detractors {
        color: $grade-zero;
      }
      .icon.nps {
        color: $info;
      }
      .label {
        height: 40px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        text-align: left;
        p {
          line-height: 20px;
          > span {
            font-weight: 100;
          }
        }
      }
    }
  }
}
.report {
  background-color: $white;
  border: 1px solid $gray-light;
  border-radius: 4px;
  color: $title-color;
  padding: 0 8px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top-color: none;
  margin-top: -2px;
  padding: 15px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/reports-emotion-cards/index.vue